import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, Database, MessageSquare, Settings } from 'lucide-react';

const PolitiqueConfidentialite = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-32 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">Politique de Confidentialité</h1>
        
        <div className="space-y-8">
          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Shield className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Introduction</h2>
            </div>
            <p className="mb-4">
              DIAGNOSTI-K s'engage à protéger la vie privée des utilisateurs de son site internet. 
              Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons 
              vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
            <p>
              En utilisant notre site, vous acceptez les pratiques décrites dans la présente politique 
              de confidentialité.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Database className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Données collectées</h2>
            </div>
            <p className="mb-4">Nous collectons les informations suivantes :</p>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Adresse postale</li>
              <li>Informations relatives à votre bien immobilier</li>
            </ul>
            <p>
              Ces informations sont collectées uniquement lorsque vous les fournissez volontairement, 
              par exemple en remplissant un formulaire de contact ou de demande de devis.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Eye className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Utilisation des données</h2>
            </div>
            <p className="mb-4">Nous utilisons vos données personnelles pour :</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Répondre à vos demandes de contact ou de devis</li>
              <li>Réaliser les diagnostics immobiliers demandés</li>
              <li>Vous envoyer des informations relatives à nos services</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Respecter nos obligations légales et réglementaires</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Lock className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Protection des données</h2>
            </div>
            <p className="mb-4">
              Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données 
              personnelles contre tout accès, modification, divulgation ou destruction non autorisés.
            </p>
            <p>
              Vos données sont conservées pendant la durée nécessaire aux finalités pour lesquelles 
              elles sont collectées et traitées, conformément aux exigences légales et réglementaires.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Settings className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Vos droits</h2>
            </div>
            <p className="mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification des données inexactes</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité de vos données</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <MessageSquare className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Nous contacter</h2>
            </div>
            <p className="mb-4">
              Pour exercer vos droits ou pour toute question concernant notre politique de confidentialité, 
              vous pouvez nous contacter :
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Par email : Spskdiag@gmail.com</li>
              <li>Par téléphone : 07 89 30 75 00</li>
              <li>Par courrier : 95 Avenue Fernand Gonnet, 84850 Camaret-sur-Aigues</li>
            </ul>
          </section>
        </div>
      </div>
    </motion.div>
  );
};

export default PolitiqueConfidentialite;